import {
  invalidate,
  request,
  shouldFetch,
  receiveForPaginationList,
  receiveForPaginationListAll,
  fetchDataForPaginationList,
  fetchDataForPaginationListAll
} from "./functions";
import { incrementFetch } from "../loaders";

const invalidateAll = (params, prefix) => ({
  type: prefix + "_INVALIDATE_ALL_" + params.code
});

export default params => ({
  invalidate: () => invalidate(params, "PLIST"),
  invalidateAll: () => invalidateAll(params, "PLIST"),
  request: () => request(params, "PLIST"),
  receive: (data, isLastPage = false) =>
    receiveForPaginationList(params, data, (isLastPage = false), "PLIST"),
  receiveAll: (data, isLastPage = false) =>
    receiveForPaginationListAll(params, data, (isLastPage = false), "PLIST"),
  shouldFetch: state => shouldFetch(state, params),
  fetchIfNeededAll: (...extraArgs) => {
    return (dispatch, getState) => {
      dispatch(request(params, "PLIST"));
      dispatch(incrementFetch());
      return dispatch(fetchDataForPaginationListAll(params, ...extraArgs));
    };
  },
  fetchIfNeeded: (...extraArgs) => {
    return (dispatch, getState) => {
      if (shouldFetch(getState(), params)) {
        dispatch(request(params, "PLIST"));
        dispatch(incrementFetch());
        return dispatch(fetchDataForPaginationList(params, ...extraArgs));
      } else {
        return Promise.resolve();
      }
    };
  },
  fetchData: postParams => fetchDataForPaginationList(params, postParams)
});
